class NavigationScrollView extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.options = {
			navPositionY     : null,
			navBarHeight     : null,
			navScrollHeight  : null,
			antiSpam         : false,
			isAnimating      : false,
			anchors          : []
		};
	}

	init() {
		this.addEvents();
		this.defineOptions();

		let scope = this;

		// Allows to check if a value is in the array
		Array.prototype.contains = function(obj) {
			let i = this.length;
			while (i--) {
				if (this[i] == obj) {
					return true;
				}
			}
			return false;
		};

		// Mettre le active sur le first child
		this.$("ul li").first().addClass('active');
	}

	addEvents() {
		$(window).on('resize', () => {this.resizeHandler()});
		Me.dispatch.subscribe('breakpointChanged', (e,params) => {this.breakpointHandler(e,params)});
		Me.dispatch.subscribe('navigation.focus', (e, params) => {this.focusHandler(e, params)});
		this.$('a').on('click', (e) => {this.linkHandler(e)});
	}

	defineOptions(){
		this.options.navPositionY     = this.$el.offset().top;
		this.options.navBarHeight     = $('.franchise-navigation').outerHeight();
		this.options.navScrollHeight  = this.$el.outerHeight();
	}

	removeEvents() {

	}

	resizeHandler(){
		this.defineOptions();
	}

	linkHandler(e){
		let anchor = $(e.currentTarget).attr('href');

		if(anchor[0] != '#'){
			// Means it's not a page scroll anchor and it's an actual link!
			return;
		}


		// Scroll to section
		e.preventDefault();
		let scrollDuration = 500;
		let newSectionOffset = $('section[data-anchor="' + anchor + '"]').offset().top;
		let scrollAmount = newSectionOffset - ( this.options.navBarHeight + this.options.navScrollHeight ) + 1;
		let scope = this;

		// Changes button state
		scope.focusHandler(this,{activeSection : anchor});

		// Animates and prevents focus bugs from the page dispatch
		this.options.antiSpam = true;
		this.options.isAnimation = true;
		$('html, body').animate({
				scrollTop : scrollAmount
			},
			{
				duration : scrollDuration,
				complete : function(){
					scope.options.isAnimating = false;
				}
			});

		setTimeout(function(){
			scope.options.antiSpam = false;
		},(scrollDuration + 100) )
	}

	focusHandler(e,params){
		// Prevents doing unecessary actions
		if( this.$('ul li a.active').attr('href') == params.activeSection || this.options.isAnimating || this.options.antiSpam){
			return;
		}

		this.$('.active').removeClass('active');
		let $target = this.$el.find('[href="' +  params.activeSection + '"]');
		$target.addClass('active');
	}

	breakpointHandler(e,params){
		if( params.breakpoint == '768-') {
			this.options.isMobile = true;
		}else{
			this.options.isMobile = false;
		}
	}
}
